import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17.561 4.409l-3.97-3.97a1.5 1.5 0 0 0-2.121 0L6.909 5H0l5.793 5.793-5.5 5.5a.999.999 0 1 0 1.414 1.414l5.5-5.5L13 18v-6.909l4.561-4.561a1.501 1.501 0 0 0 0-2.121z" />
  </svg>
);

export default SvgComponent;
